import type { ReactNode } from 'react';

/**
 * Constrains content width on wide desktop viewports. Fixes blueprint
 * finding §14 (wide-desktop regression — dashboard/job-detail cards
 * stretching unreadably wide with no max-width anywhere in the layout).
 */
export function CustomerPageContainer({ children }: { children: ReactNode }) {
  return <div className="mx-auto w-full max-w-7xl">{children}</div>;
}
